module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/banner_info.a1b2ac33.jpg";